import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {TIMEOUT_STORE} from 'util/constants';
import {readColors} from 'config/highcharts';
import {getColorIndex} from 'util/utils';

const
    mapFields = {
        account_id: 'accountId'
    },
    transformEntitiesFn = account => ({
        id:                account.id,
        account_id:        account.account_id,
        vendor_account_id: account.vendor_account_id,
        name:              account.alias,
        reselling:         account.reselling,
        msp:               account.msp,
        vendor:            account.vendor.code,
        accounts:          [
            {
                id:              account.account_id,
                alias:           account.alias,
                has_credentials: account.has_credentials
            }
        ],
        ...account.extra
    }),

    transformEntitiesToSaveFn = account => ({
        alias: account.name
    });


const exports = storeModuleFactory({
    name:             'accounts',
    endpoint:         endpoints.accounts.endpoint,
    instanceEndpoint: endpoints.accounts.instanceEndpoint,
    extraActions:     [{
        method: 'update',
        action: 'updateUserAlias',
        url:    endpoints.accounts.instanceEndpoint,
        start:  state => ({
            ...state,
            isUpdating: true,
            error:      null
        }),
        success: state => ({
            ...state,
            isUpdating:    false,
            didInvalidate: true,
            error:         null
        }),
        transform: item => item
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

const _colors = readColors();
const _getAccountColor = accountName => {
    const index = getColorIndex(accountName);

    return _colors[index];
};

exports.getAccountColor = _getAccountColor;
exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.createFetchParams = (pagination, ordering = {}, filters = {}) => ({
    ...pagination,
    ...filters,
    ordering
});

exports.mapFields = mapFields;
module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/accounts.js